import { Fragment, type ReactNode } from "react";

/** `**bold**` → <strong>; everything else stays text (React escapes it). */
export const InlineText = ({ text }: { text: string }): ReactNode =>
  text
    .split(/\*\*(.+?)\*\*/g)
    .map((part, index) => (index % 2 === 1 ? <strong key={index}>{part}</strong> : part));

/** A blank line starts a new paragraph; a single newline becomes <br>. */
export const Paragraphs = ({ text }: { text: string }): ReactNode =>
  text
    .trim()
    .split(/\n\s*\n/)
    .map((paragraph, index) => (
      <p key={index}>
        {paragraph.split("\n").map((line, lineIndex) => (
          <Fragment key={lineIndex}>
            {lineIndex > 0 && <br />}
            <InlineText text={line} />
          </Fragment>
        ))}
      </p>
    ));
